// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { ChevronRight } from '@mui/icons-material';
import { Box, Card, IconButton, Typography } from '@mui/material';

interface SettingsPreviewProps {
  onClick: () => void;
  title: string;
  desc: string;
  enableBodyClick?: boolean;
}
export const SettingsPreview: React.FC<SettingsPreviewProps> = ({
  enableBodyClick,
  onClick,
  title,
  desc,
}) => {
  return (
    <Card
      onClick={enableBodyClick ? onClick : undefined}
      sx={{
        cursor: enableBodyClick ? 'pointer' : 'default',
        mb: 1,
        width: '50%',
        p: 1,
        display: 'flex',
        alignItems: 'center',
      }}
      variant="outlined"
    >
      <Box>
        <Typography fontWeight="bold">{title}</Typography>
        <Typography variant="body2">{desc}</Typography>
      </Box>
      <Box sx={{ ml: 'auto' }}>
        <IconButton aria-label={title} onClick={enableBodyClick ? undefined : onClick}>
          <ChevronRight />
        </IconButton>
      </Box>
    </Card>
  );
};
